import { r as g, i as h, c as d, n as u, B as E } from "./abstract-base-CdeHT0x1.js";
import { P as T } from "./passthroughAttributes-DqDJ2_cW.js";
import { m as I } from "./mixin-DsSIi_3b.js";
import { p as D, m as y } from "./lifecycle-decorators-VlFt_asj.js";
import { c as O, b as v, a as m } from "./query-assigned-DiX8lRAH.js";
var S = /* @__PURE__ */ ((t) => (t.LOADING = "loading", t.PROGRESS = "progress", t.SUCCESS = "success", t.RESULT = "result", t.NONE = "", t))(S || {}), p = /* @__PURE__ */ ((t) => (t.SUBMIT = "submit", t.BUTTON = "button", t.RESET = "reset", t.MENU = "menu", t))(p || {}), x = /* @__PURE__ */ ((t) => (t.PRIMARY = "primary", t.SECONDARY = "secondary", t.TERTIARY = "tertiary", t.POSITIVE = "positive", t.NEGATIVE = "negative", t))(x || {}), _ = Object.defineProperty, N = Object.getOwnPropertyDescriptor, b = (t, e, n, o) => {
  for (var s = o > 1 ? void 0 : o ? N(e, n) : e, i = t.length - 1, a; i >= 0; i--)
    (a = t[i]) && (s = (o ? a(e, n, s) : a(s)) || s);
  return o && s && _(e, n, s), s;
};
function k(t = { clean: !1 }) {
  return function(n) {
    let o = class extends n {
      /**
       * Removes any whitespace from the default slot.
       *
       * Default slots can see whitespace or new line characters as node slotted in, which can cause presentational issues when there's fallback content in the slot's position.
       *
       * This issue is commonly seen in AEM applications but can be a result of any templating syntax that doesn't trim whitespace from HTML nodes the whole way.
       */
      cleanDefaultSlot() {
        this.defaultSlotNodes.forEach((s) => {
          var i;
          !s.slot && !((i = s.textContent) != null && i.trim()) && s.remove();
        });
      }
      /** Sets internal state for slot text and existance of slot content */
      setDefaultSlotText() {
        this.defaultSlotText = this.getDefaultSlotText(), t.clean && this.cleanDefaultSlot();
      }
      /** Grabs slotted text and sets the state defaultSlotText property. */
      getDefaultSlotText() {
        if (this.defaultSlotNodes.length > 0)
          return this.defaultSlotNodes.map((s) => {
            var i, a;
            return (a = (i = s.textContent) == null ? void 0 : i.trim()) != null ? a : "";
          }).join("");
      }
      postrenderSetDefaultSlotText() {
        this.setDefaultSlotText();
      }
    };
    return b([
      g()
    ], o.prototype, "defaultSlotText", 2), b([
      O({ flatten: !0 })
    ], o.prototype, "defaultSlotNodes", 2), b([
      D
    ], o.prototype, "postrenderSetDefaultSlotText", 1), o = b([
      y("TracksDefaultSlot")
    ], o), o;
  };
}
const w = h`.beacon-button-icon{align-self:var(--beacon-button-icon-align, center);block-size:var(--beacon-reference-space-5);inline-size:var(--beacon-reference-space-5)}.beacon-button-icon .beacon-button-icon--icon{fill:currentcolor}.beacon-button-icon .beacon-button-icon--stroke{stroke:currentcolor}.close-button-wrapper .beacon-button-icon{block-size:unset;inline-size:unset}[beacon-tag-name=beacon-icon-button] .beacon-button-icon{block-size:var(--override-icon-button-block-size, var(--beacon-reference-space-7));inline-size:var(--override-icon-button-inline-size, var(--beacon-reference-space-7))}`, A = h`:host([motion-state=enabled]) a,:host([motion-state=enabled]) button,:host([motion-state=enabled]) .icon-button{--button-base-transition-property: background-color;transition-duration:var(--button-base-transition-duration, 0s);transition-property:var(--button-base-transition-property);transition-timing-function:var(--button-base-transition-timing-function, var(--beacon-system-motion-easing-decelerate-emphasize-1))}:host([motion-state=enabled]) a .contents,:host([motion-state=enabled]) button .contents,:host([motion-state=enabled]) .icon-button .contents{transition-duration:inherit;transition-property:transform;transition-timing-function:inherit}`;
var C = Object.getOwnPropertyDescriptor, B = (t, e, n, o) => {
  for (var s = o > 1 ? void 0 : o ? C(e, n) : e, i = t.length - 1, a; i >= 0; i--)
    (a = t[i]) && (s = a(s) || s);
  return s;
};
function P(t) {
  let e = class extends t {
    static get ButtonBaseMotionStyles() {
      return [A];
    }
  };
  return e = B([
    y("ButtonBaseMotion")
  ], e), e;
}
const M = h`:host(:not(.skip-focus-override)) :is(button,a):focus-visible{box-shadow:0 0 0 var(--beacon-system-width-border-jumbo) var(--beacon-system-color-border-focus-middle),0 0 0 var(--beacon-system-width-border-maxi) var(--beacon-system-color-border-focus-outer);outline:var(--beacon-system-width-border-normal) solid var(--beacon-system-color-border-focus-inner);outline-offset:0;z-index:1}:host(:not(.skip-focus-override)) :is(button,a):focus-visible:not(dialog){position:relative}:host(:not(.skip-focus-override)) :is(button,a).tertiary:focus-visible{--second-ring-width: calc(var(--beacon-system-width-border-jumbo) + var(--beacon-system-width-border-normal));box-shadow:0 0 0 var(--second-ring-width) var(--beacon-system-color-border-focus-outer);outline:var(--beacon-system-width-border-normal) solid var(--beacon-system-color-border-focus-middle);outline-offset:0;position:relative;z-index:1}`;
var R = Object.defineProperty, l = (t, e, n, o) => {
  for (var s = void 0, i = t.length - 1, a; i >= 0; i--)
    (a = t[i]) && (s = a(e, n, s) || s);
  return s && R(e, n, s), s;
};
const f = {
  icon: "beacon-button-icon",
  strokeFill: "beacon-button-icon--stroke",
  iconFill: "beacon-button-icon--icon"
}, L = "stroke";
var c;
const r = (c = class extends I(E).with(
  P,
  k({ clean: !0 })
) {
  constructor() {
    super(...arguments), this._passthroughs = new T(this), this.focusOverride = !0, this.SLOTTED_ICON_INDEX = 0, this.type = p.BUTTON, this.variant = x.PRIMARY, this.state = S.NONE, this.disabled = !1, this.linkHref = "";
  }
  static get styles() {
    return [super.styles, M, this.ButtonBaseMotionStyles];
  }
  static get lightDOMStyles() {
    return [super.lightDOMStyles, w];
  }
  /**
   * Implement `ElementInternals.setValidity()` with default values.
   * @param flags Custom validation flags.
   * @param message Error message used in validation.
   * @param anchor Validation target to receive focus, typically the form control element used in the shadow DOM.
   */
  setValidity(e, n, o = this.formAnchor) {
    this._internals && this._internals.setValidity(e, n, o);
  }
  get prefixIcon() {
    return this.prefixIconElements[this.SLOTTED_ICON_INDEX];
  }
  get suffixIcon() {
    return this.suffixIconElements[this.SLOTTED_ICON_INDEX];
  }
  /**
   * Returns the first element in the icon slot
   */
  get icon() {
    return this.iconElements[this.SLOTTED_ICON_INDEX];
  }
  /**
   * Event listener for internal HTML button that
   * determines click behavior depending on its disabled state
   * and button type.
   * @param event click event
   * @event {BeaconEvents} beacon-event-click - Emits when clicked
   */
  handleClick(e) {
    var n, o;
    if (this.disabled)
      e.preventDefault(), e.stopPropagation(), e.stopImmediatePropagation();
    else if (this.emitClick(), this._internals)
      switch (this.type) {
        case p.SUBMIT:
          (n = this._internals.form) == null || n.requestSubmit();
          break;
        case p.RESET:
          (o = this._internals.form) == null || o.reset();
          break;
      }
  }
  /**
   * Applies proper CSS class to slotted SVG such that it renders correctly
   * @param element reference to the slotted SVG
   */
  static applySVGClass(e) {
    e && Array.from(e.children).forEach((n) => {
      if (n) {
        const o = n.getAttribute(L) ? f.strokeFill : f.iconFill;
        n.classList.add(o);
      }
    });
  }
  handleIconSlotchange() {
    if (this.iconElements.length > 0)
      for (const e of this.iconElements) {
        e.classList.add(f.icon);
        const n = this.defaultSlotText;
        d(e, n), c.applySVGClass(e);
      }
  }
  handleAffixSlotChanges({ target: e }) {
    if (e instanceof HTMLSlotElement) {
      const n = e.name;
      if (n === "suffix" && this.suffixIcon) {
        this.suffixIcon.classList.add(f.icon);
        const o = this.defaultSlotText;
        d(this.suffixIcon, o), c.applySVGClass(this.suffixIcon);
      } else if (n === "prefix" && this.prefixIcon) {
        this.prefixIcon.classList.add(f.icon);
        const o = this.defaultSlotText;
        d(this.prefixIcon, o), c.applySVGClass(this.prefixIcon);
      }
    }
  }
}, c.formAssociated = !0, c);
l([
  v(".form-anchor")
], r.prototype, "formAnchor");
l([
  u({ reflect: !0 })
], r.prototype, "type");
l([
  u()
], r.prototype, "variant");
l([
  u()
], r.prototype, "state");
l([
  u({ type: Boolean })
], r.prototype, "disabled");
l([
  u({ attribute: "link-href" })
], r.prototype, "linkHref");
l([
  u({ attribute: "link-download" })
], r.prototype, "linkDownload");
l([
  u({ attribute: "link-target" })
], r.prototype, "linkTarget");
l([
  m({ flatten: !0, slot: "icon", selector: "svg" })
], r.prototype, "iconElements");
l([
  m({
    flatten: !0,
    slot: "prefix",
    selector: "svg"
  })
], r.prototype, "prefixIconElements");
l([
  m({
    flatten: !0,
    slot: "suffix",
    selector: "svg"
  })
], r.prototype, "suffixIconElements");
l([
  v("button, a")
], r.prototype, "button");
let V = r;
export {
  V as B,
  x as C,
  k as T,
  S as a,
  p as b
};
